import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { StyledBorderedCard } from './BordererCard.styles.js';

const BordererCard = (_a) => {
    var { children } = _a, restProp = __rest(_a, ["children"]);
    return jsx(StyledBorderedCard, Object.assign({}, restProp, { children: children }));
};

export { BordererCard as default };
//# sourceMappingURL=BordererCard.js.map
